import React, {useCallback, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Modal} from 'antd'

import {ColoredAddressIcon} from 'components/CustomIcons'
import useUserContext from 'components/User/useUserContext'
import DeliveryAddressBlock from 'modules/UserProfile/Settings/DeliveryAddressBlock'
import PostcodeAutoComplete from 'modules/UserProfile/ModalAddress/PostcodeAutoComplete'

const ModalHeading = ({t, children}) => (
  <>
    <div className='modal-deliveryAddressHeader'>
      <ColoredAddressIcon/>
      <h3>
        {t('Where should we deliver your order?')}
      </h3>
    </div>

    <div className='modal-deliveryAddressContent'>
      {children}
    </div>
  </>
)


const ModalAddress = ({deliveryModal, setDeliveryModal}) => {
  const {t} = useTranslation()
  const {user, delivery, setDelivery} = useUserContext()

  const [inputValue, setInputValue] = useState({})

  const setSelectedAddressParser = useCallback(selectedPostcode => {
    localStorage.setItem('zip', JSON.stringify({zip: selectedPostcode}))
    setDelivery({zip: selectedPostcode})
  }, [setDelivery])

  const setSelectedAddress = useCallback(e => {
    if (e?.uuid) localStorage.setItem('deliveryAddressUuid', e.uuid)
    setDeliveryModal(false)
  }, [setDeliveryModal])

  useEffect(() => {
    setSelectedAddress(delivery)
  }, [delivery, setSelectedAddress])

  return (
    <Modal
      visible={deliveryModal}
      onCancel={_ => setDeliveryModal(false)}
      footer={null}
      wrapClassName='modal-deliveryAddress'
      width={'40em'}
    >
      {user?.customerProfile?.deliveryAddresses?.length ? (
        <DeliveryAddressBlock
          t={t}
          deliveryAddresses={user.customerProfile.deliveryAddresses}
        />
      ) : (
        <ModalHeading t={t}>
          <PostcodeAutoComplete
            inputValue={inputValue}
            setInputValue={setInputValue}
            setSelectedAddressParser={setSelectedAddressParser}
            t={t}
          />
        </ModalHeading>
      )}
    </Modal>
  )
}

export default ModalAddress
